<script lang="ts" setup>
import BigButton from "~/components/sx/components/BigButton.vue";
import ScrollDefault from "~/components/sx/videoSequence/ScrollDefault.vue";

const { t } = useI18n();
const config = useRuntimeConfig();
</script>

<template>
  <section class="sx-hero">
    <div class="sx-hero__desc">
      <h1 class="sx-landing-title title">
        {{ $t('pages.home.hero.title') }}
      </h1>
      <p class="sx-hero__subtitle sx-landing-subtitle">
        {{ $t('pages.home.hero.many') }}
        <span class="sx-hero__separator">–</span>
        {{ $t('pages.home.hero.clean') }}
        <span class="sx-hero__separator">–</span>
        {{ $t('pages.home.hero.profitable') }}
      </p>
      <div class="sx-hero__controls">
        <a class="sx-hero__btn default-tag sx-hero__btn--transparent" href="https://proxysell.com/">
          {{ $t('pages.home.hero.sellProxy') }}
        </a>
        <BigButton
          :text="$t('pages.home.hero.buyProxy')"
          :to="config.public.signinUrl"
        />
      </div>
    </div>
    <scroll-default />
  </section>
</template>

<style lang="scss" scoped>
.sx-hero {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  text-align: center;
  &__img {
    width: 100%;
  }
  .title {
    @media (max-width: 460px) {
      max-width: 300px;
    }
  }

  &__separator {
    margin: 0 12px;
  }

  &__controls {
    display: flex;
    align-items: center;
    gap: 11px;
  }

  &__btn {
    padding: 15px 20px;
    border-radius: 100px;
    cursor: pointer;
    font-size: 18px;
    font-weight: 400;
    line-height: 20px;
    color: #000;
    height: 52px;
    @media (max-width: 600px) {
      height: 44px;
      padding: 16px;
      border-radius: 22px;
      font-size: 16px;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    &--transparent {
      border: 1px solid #000000;

      &:hover {
        color: #000;
        background: #eeeeee;
      }

      &:active {
        background: #F7F7F7;
      }
    }
  }

  &__desc {
    display: flex;
    flex-direction: column;
    align-items: center;
    z-index: 499;
    position: relative;
    padding: 0 2rem;
  }

  &__title {
    max-width: 1200px;
    font-size: 75px;
    line-height: 80px;
    font-weight: 700;
    letter-spacing: -0.03em;
    text-align: center;

    @media (width < 480px) {
      font-size: 36px;
      line-height: 125%;
      font-weight: 700;
    }
  }

  &__subtitle {
    text-align: center;
    margin: 20px 0 32px;
  }

  &__video {
    max-height: 90vh;
  }
}

@media (max-height: 1000px) {
  .sx-hero {
    &__desc {

      padding-top: 0;
    }
  }
}

@media (min-width: 3000px) {
  .sx-hero__video {
    max-height: 96vh;
  }
}

@media (max-width: 600px) {
  .sx-hero {
    &__controls {
      flex-direction: column;
    }
  }
}
</style>
